import { cn } from '@distribute/frontend/utils';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLTableElement> & {
  className?: string;
};

export const Table: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <table
      {...props}
      className={cn('w-full border-separate border-spacing-0', className)}
    >
      {children}
    </table>
  );
};
